jQuery(document).ready(function ($) {
    $('.menu-toggle').click(function () {
        if ($('.main-nav').hasClass('is-open')) {
            closeMenu();
        } else {
            openMenu();
        }
    });
    $('#close-button, .menu-background-overlay').click(function () {
        closeMenu();
    });
});

function openMenu() {
    jQuery('.menu-toggle').addClass('is-open');
    jQuery('.main-nav').addClass('is-open');
    jQuery('.menu-background-overlay').addClass('is-open');
}

function closeMenu() {
    jQuery('.menu-toggle').removeClass('is-open');
    jQuery('.main-nav').removeClass('is-open');
    jQuery('.menu-background-overlay').removeClass('is-open');

}